import { dateRequiredSchema, endDateSchema, select2RequiredSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, number, object } from 'yup';

const createGroupSchema = object().shape({
    group_image: stringRequiredSchema,
    group_name: stringRequiredSchema,
    start_date: dateRequiredSchema,
    end_date: endDateSchema,
    group_type: select2RequiredSchema,
    description: stringOptionalSchema
});

export default createGroupSchema;